export default __webpack_public_path__ + "static/media/Main-Layout-Header-Image-Tablet.137161ef.png";